import { skipToken } from '@reduxjs/toolkit/query';
import { useMemo } from 'react';
import { useGetBlockQuery } from '../impl/blfApi/endpoints/blocks';

/**
 * Wrapper around useGetBlockQuery that skips if blockId is not provided
 * @param blockId the id of the block
 * @param queryOptions options to pass to useGetBlockQuery, including additional skip condition(s)
 * @returns query result
 */

export const useBlock = (
  blockId: string | undefined,
  queryOptions?: {
    skip?: boolean;
  }
) => {
  const queryParams = useMemo(() => {
    if (!blockId || queryOptions?.skip) {
      return skipToken;
    }

    return blockId;
  }, [blockId, queryOptions?.skip]);

  const {
    data: block,
    isLoading,
    isFetching,
  } = useGetBlockQuery(queryParams, queryOptions);

  return { block, isBlockLoading: isLoading || isFetching };
};
